module.exports = __webpack_public_path__ + "50c5e3e79b276c92df6cc52caeb464f0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/layer/loading-2.gif
// module id = 1043
// module chunks = 73